<template>
  <div class="page flex-col">
    <div class="select_container flex-row">
      <SearchInput
        class="select_item"
        placeholder="搜索学生"
        @search="handleSearch"
        @input="handleInputChange"
      />

      <Dropdown
        class="select_item"
        :options="academicOptions"
        placeholder="学年"
        @selection-change="handleYearSelection"
      />

      <Dropdown
        class="select_item"
        :options="classOptions"
        placeholder="班级"
        @selection-change="handleClassSelection"
      />
    </div>

    <div class="info flex-row">
      <span class="text_info">{{ total }}位学生</span>
    </div>

    <div class="list_container">
      <DataTable
        :headers="tableHeaders"
        :items="loopData"
        show-pagination="true"
        :total="total"
        :pageSize="pageSize"
        :currentPage="currentPage"
        @item-click="handleItemClick"
        @page-change="handlePageChange"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import { useRouter } from "vue-router"
import { useStore } from "vuex"

import DataTable from "@/components/teacher/DataTable.vue"
import Dropdown from "@/components/teacher/Dropdown.vue"
import SearchInput from "@/components/teacher/SearchInput.vue"
import alovaInstance from "@/utils/alova"

const router = useRouter()
const store = useStore()
const tableHeaders = [
  {
    key: "academicYear",
    label: "学年",
    style: "width: 8vw;",
    cellStyle: "width: 14vw;",
  },
  {
    key: "classNo",
    label: "班级（ID）",
    style: "width: 13vw;",
    cellStyle: "width: 8vw;text-align: left;margin-left: 1.8vw;",
  },
  {
    key: "className",
    label: "班级（名称）",
    style: "width: 13vw;",
    cellStyle: "width: 14vw;text-align: left;margin-left: 3.8vw;",
  },
  {
    key: "studentNo",
    label: "学号",
    style: "width: 14vw;",
    cellStyle: "width: 12vw;text-align: left;margin-left: 4.2vw;",
  },
  {
    key: "studentName",
    label: "姓名",
    style: "width: 13vw;",
    cellStyle: "width: 14vw;text-align: left;margin-left: 1.1vw;",
  },
  {
    key: "gender",
    label: "性别",
    style: "width: 15vw;",
    cellStyle: "width: 12vw;text-align: left;margin-left: 1.6vw;",
  },
]
// const academicOptions = ref(["2024-2025"])
// const loopData = ref([
//   {
//     academicYear: "2024-2025",
//     classNo: "1",
//     className: "test",
//     studentNo: "test001",
//     studentName: "stu001",
//     gender: "男",
//   },
// ])
// const classOptions = ref([{ label: "S1A", value: 1 }])
const academicOptions = ref([])
const loopData = ref([])
const classOptions = ref([])

const studentName = ref("")
const academicYear = ref("")
const classId = ref(-1)
const currentPage = ref(1)
const pageSize = ref(10)
const total = ref(0)

onMounted(async () => {
  try {
    const response = await alovaInstance.Post("/Class/GetAllAcademic")
    if (response.code === 1000) {
      academicOptions.value = response.data
    } else {
      alert("获取数据失败：" + response.message)
    }

    const allClass = await alovaInstance.Post("/Class/GetAllClass")
    if (allClass.code === 1000) {
      // console.log(allClass.data)
      classOptions.value = []
      for (let i = 0; i < allClass.data.length; i++) {
        classOptions.value.push({
          label: allClass.data[i].class_name,
          value: allClass.data[i].id,
        })
      }
    } else {
      alert("获取数据失败：" + allClass.message)
    }

    handleSelection()
  } catch (error) {
    console.error("获取数据失败:", error)
    alert("获取数据失败，请稍后重试")
  }
})

const handleItemClick = (item) => {
  store.dispatch("setCurrentStudent", item)
  router.push({
    path: "/teacher/student",
  })
}

const handleSearch = (value) => {
  // console.log("Search student:", value)
  studentName.value = value
  handleSelection()
}

const handleInputChange = (value) => {
  // console.log("Input changed:", value)
  studentName.value = value
  handleSelection()
}

const handleYearSelection = (year) => {
  // console.log("Selected year:", year)
  academicYear.value = year
  handleSelection()
}

const handleClassSelection = (value) => {
  // console.log("Selected class:", value)
  classId.value = value
  handleSelection()
}

const handlePageChange = (page) => {
  currentPage.value = page
  handleSelection()
}

const handleSelection = async () => {
  try {
    const response = await alovaInstance.Post(
      "/Student/GetStudentsByFilterCondition",
      {
        studentName: studentName.value,
        academicYear: academicYear.value,
        classId: classId.value,
        pageIndex: currentPage.value,
        pageSize: pageSize.value,
      }
    )
    // console.log(response)
    if (response.code === 1000 && response.data != null) {
      loopData.value = response.data.studentInfoList
      // loopData.value = loopData.value.concat(loopData.value).concat(loopData.value)
      total.value = response.data.totalCount
    } else if (response.code === 1000 && response.data == null) {
      loopData.value = []
      total.value = 0
      alert("没有符合条件的学生")
    } else {
      alert("获取数据失败：" + response.message)
    }
  } catch (error) {
    console.error("获取数据失败:", error)
    alert("获取数据失败，请稍后重试")
  }
}
</script>

<style src="@/assets/common.css" />
<style scoped>
.page {
  background-color: rgba(234, 238, 242, 1);
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
}

.select_container,
.info {
  width: auto;
  height: auto;
  margin: 0;
}

.select_item {
  margin: 0.89vw 0 0 1.25vw;
}

.text_info {
  width: 3.75vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.36vw;
  margin: 0.89vw 0 0 1.25vw;
}

.list_container {
  position: relative;
  width: 80.68vw;
  /* height: auto; */
  height: 38vw;
  margin-left: 1.25vw;
  margin-top: 0.6vw;
}
</style>
